import services from '@/services'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (async (event: MessageEvent) => {
    const data: any = JSON.parse(event.data)
    if (data && data.request) {
      if (data.request === 'renewToken') {
        console.log('Renew Token from service-worker...')
        let response: any
        try {
          response = await services.auth.renew()
        } catch (e) {
          console.error(e)
          response = null
        }
        event.ports[0].postMessage(JSON.stringify(response ? response.data : null))
      }
    }
  }))
}
